import ProductAdmin from "../../../Components/Admin/Product";

const ProductAdminPage = () => {
  return <ProductAdmin />;
};

export default ProductAdminPage;
